import Button from '@components/Button';
import useProject from '@hooks/useProject';
import { ShopOrderStatus, ShopStatus } from '@models/shop/common';
import { useFlow } from '@router/stackflow';
import { useMemo } from 'react';

import styles from './styles.module.scss';

interface Props {
    shopId: string;
    status: ShopOrderStatus;
    shopStatus: ShopStatus;
}

function OrderButton({ shopId, status, shopStatus }:Props) {
  const { push, pop } = useFlow();
  const disabled = status !== 'OPEN';
  const project = useProject();
  const message = useMemo(() => {
    console.log({ shopStatus });
    if (project?.features.orderEnabled) {
      if (shopStatus === 'NOT_USE_APP_ORDER') {
        return '메뉴 보러 가기';
      }
      return disabled ? '준비중입니다' : ' 주문하러 갈까요?';
    }
    return '메뉴보러 가기';
  }, [disabled, project, shopStatus]);
  return (
        <div className={styles.order}>
            <Button fullWidth
                    disabled={disabled}
                    onClick={() => {
                      pop();
                      push('ItemsActivity', { shopId, type: 'ALL' });
                    }}>
                {message}
            </Button>
        </div>
  );
}

export default OrderButton;
